import React from 'react';

class Footer extends React.Component {
  render() {
    return (
      <footer>
        <p className="cabecalho"> &copy; 2022. Desenvolvido por Yasmin Amorin </p>
      </footer>
    );
  }
}

export default Footer;
